import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { API } from "@/lib/api";

const LABELS = { fr: "Voir la vidéo de démonstration", en: "Watch the demo video", de: "Demo-Video ansehen", ar: "شاهد فيديو العرض التوضيحي" };
const CLIP = [52, 63];

function visitorId() {
  let v = localStorage.getItem("pi_visitor");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("pi_visitor", v); }
  return v;
}

function trackClick(lang, source) {
  const body = JSON.stringify({ lang, source, visitor: visitorId() });
  const blob = new Blob([body], { type: "application/json" });
  if (!(navigator.sendBeacon && navigator.sendBeacon(`${API}/video/clic`, blob))) {
    fetch(`${API}/video/clic`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  }
}

function HoverPreview({ lang }) {
  const loop = (e) => { const v = e.currentTarget; if (v.currentTime >= CLIP[1] || v.currentTime < CLIP[0] - 1) v.currentTime = CLIP[0]; };
  return (
    <div className="btn-3d-preview" data-testid="video-demo-preview">
      <video src={`/video/path-intelligent-${lang}.mp4${lang === "fr" ? "?v=2" : ""}#t=${CLIP[0]}`} muted autoPlay playsInline preload="auto" onTimeUpdate={loop}
             className="block w-full h-full object-cover" />
      <span className="btn-3d-preview-tag">▶ Aperçu</span>
    </div>
  );
}

export const VideoDemoButton = ({ testId = "video-demo-button" }) => {
  const { lang } = useLang();
  const l = LABELS[lang] ? lang : "fr";
  const [hover, setHover] = useState(false);
  const timer = useRef(null);
  const enter = () => { timer.current = setTimeout(() => setHover(true), 250); };
  const leave = () => { clearTimeout(timer.current); setHover(false); };
  return (
    <span className="relative inline-block" onMouseEnter={enter} onMouseLeave={leave}>
      {hover && <HoverPreview lang={l} />}
      <a href={`/v?l=${l}`} target="_blank" rel="noopener" className="btn-3d-video" data-testid={testId}
         onClick={() => trackClick(l, testId.startsWith("card") ? "accueil-mobile" : "accueil")}>
        <span className="btn-3d-icon"><Play className="h-4 w-4 fill-current" /></span>
        <span>{LABELS[l]}</span>
      </a>
    </span>
  );
};
